import { useFormContext } from "react-hook-form";

import style from "./FormField.module.css";

const getNestedError = (errors, path) => {
  const parts = path.split(".");

  return parts.reduce((acc, part) => {
    if (!acc) return undefined;
    return acc[part];
  }, errors);
};

export const FormField = ({ children, name, label }) => {
  const {
    formState: { errors },
  } = useFormContext();

  const fieldError = name ? getNestedError(errors, name) : undefined;

  return (
    <div
      // Lets a refused submit scroll to the field that refused. Most fields here are Select
      // components driven by setValue rather than register, so they hold no ref and
      // react-hook-form's own shouldFocusError has nothing to focus.
      data-form-field={name}
      className={`${style.formField} ${
        fieldError ? `${style.formFieldError} form-field-controll-error` : ""
      } form-field-controll`}
    >
      {label && <label className={style.label}>{label}</label>}
      {children}
      {fieldError && <p>{fieldError.message}</p>}
    </div>
  );
};
